import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { Toaster } from 'react-hot-toast'

import './index.css'
import App from './App.jsx'
import { LangProvider } from './lib/i18n.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <LangProvider>
        <BrowserRouter>
          <App />
          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                background: '#2A3270',
                color: '#FFFFFF',
                border: '1px solid rgba(255,255,255,0.16)',
                borderRadius: '12px',
                fontFamily: 'Montserrat, sans-serif',
              },
            }}
          />
        </BrowserRouter>
      </LangProvider>
    </HelmetProvider>
  </StrictMode>,
)
